import React from 'react';

import { FAQCategory, FAQCategoryType, FAQConfig, FAQItem, ListItem } from '../types';

import FAQAccordion from './FAQAccordion';
import FAQList from './FAQList';

type Props = {
  content: FAQConfig | FAQCategory;
};

const FAQContent = ({ content }: Props): JSX.Element => {
  return (
    <>
      {content.description && <p>{content.description}</p>}
      {content.type === FAQCategoryType.ACCORDION ? (
        <FAQAccordion items={content.items as FAQItem[]} />
      ) : (
        <FAQList items={content.items as ListItem[]} />
      )}
    </>
  );
};

export default FAQContent;
